import React, { Component, Fragment } from 'react'
import axios from 'axios'
import swal from 'sweetalert'

import { OverlayTrigger, Glyphicon, FormControl } from 'react-bootstrap'

import { handleErrorFetchingData }  from '../../functions/errorHandling'

class Document extends Component {

  state = {
    editMode: false,
    updatedCategory: this.props.document.category,
    updatedFile: '',
  }

  toggleEditMode = () => {
    return this.setState({ editMode: !this.state.editMode })
  }

  handleCategoryChange = (event) => {
    this.setState({ updatedCategory: event.target.value })
  }

  handleFileChange = (e) => {
    const updatedFile = e.target.files[0]
    this.setState({ updatedFile })
  }

  saveDocument = () => {
    const url = this.props.document.url
    const { updatedCategory, updatedFile } = this.state

    if (updatedCategory.length === 0) {
      return swal({
        title: "Error",
        text: "Please enter a category",
        icon: "error",
        button: "Continue",
      })
    }

    if (updatedCategory.length > 255) {
      return swal({
        title: "Error",
        text: "Category length must not exceed 255 characters",
        icon: "error",
        button: "Continue",
      })
    }

    let updatedDocument = new FormData()

    if (updatedFile) {
      updatedDocument.append('document', updatedFile)
      updatedDocument.append('name', updatedFile.name)
      updatedDocument.append('size', updatedFile.size)
    }

    if (updatedCategory) {
      updatedDocument.append('category', updatedCategory)
    }

    swal({
      text: "Updating file... Please stand by.",
      icon: require("../../static/images/spinner.gif"),
      button: false,
      closeOnClickOutside: false,
    })

    axios({
      method: "PATCH",
      url: url,
      data: updatedDocument,
      headers: {"Authorization": "Bearer "+ localStorage.getItem("token")}
    })
    .then(response => {
      swal({
        title: "Success",
        text: "The file has been updated",
        icon: "success",
        button: "Continue",
      })
      this.props.editUploadedDocument(response.data)
      this.toggleEditMode()
    })
    .catch(error => {
      const message = "There was an error updating the document."
      handleErrorFetchingData(error, message)
    })
  }

  render() {
    const { document } = this.props
    const size = document.size /1000000

    return (
      <tr>
        <td>
          {this.state.editMode ?
            <input type="file" name="file"
              onChange={this.handleFileChange}
            />
            :
            <a
              href={document.document}
              target="_blank"
              rel='noopener noreferrer'
            >
            {document.name}
          </a>
        }
        </td>
        <td>
          {`${size.toFixed(2)} MB`}
        </td>
        <td>
          {this.state.editMode ?
            <FormControl
              type="text"
              placeholder="Enter category"
              value={this.state.updatedCategory}
              onChange={this.handleCategoryChange}
            />
            :
            document.category
          }
        </td>
        <td style={{textAlign: 'center'}}>
          {this.state.editMode ?
            <Fragment>
              <Glyphicon
                glyph="ok"
                className="document-action-icon"
                onClick={this.saveDocument}
              />
              <Glyphicon
                glyph="remove"
                className="document-action-icon"
                onClick={this.toggleEditMode}
              />
            </Fragment>
            :
            <Fragment>
              <Glyphicon
                glyph="pencil"
                className="document-action-icon"
                onClick={this.toggleEditMode}
              />
              <OverlayTrigger
                placement="top"
                trigger="click"
                rootClose
                overlay={this.props.renderDeletePopover(document.url)}
              >
                <Glyphicon glyph="trash" className="document-action-icon"/>
              </OverlayTrigger>
            </Fragment>
          }
        </td>
      </tr>
    )
  }
}

export default Document



// WEBPACK FOOTER //
// ./src/reuseable-components/documentation/Document.js